import { Route, Routes } from "react-router-dom";
import "./App.css";

import Home from "./pages/home/Home";
import DigitalRecongnization from "./pages/digitalrecongnization/Digitalrecongnization";

function App() {
  return (
    <>
      <div>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/digitalrecongnization" element={<DigitalRecongnization />}></Route>
        </Routes>
      </div>
    </>
  );
}

export default App;
